import React from 'react';
import TopOfNav from "../../layouts/topOfNav/topOfNav.component";
import NavBar from "../../layouts/navbar/navbar.component";
import DrawerNav from "../../components/drawer/drawer.component";
import Footer from "../../layouts/footer/footer.component";
import SubHeaderComponent from "../../components/subHeader/subHeader.component";
import NewsHeader from '../../assets/image/singleNewsHeader.png';
import NewsLayout from "../../layouts/news/news.layout";

const SingleNews = () => {
    return (
        <div>
            <TopOfNav/>
            <NavBar/>
            <DrawerNav/>
            <SubHeaderComponent imageSrc={NewsHeader} pageName='اخبار'/>
            <NewsLayout/>
            <Footer/>
        </div>
    );
};

export default SingleNews;